export default "__VITE_ASSET__DOJXrw5W__"